import { Controller } from "@hotwired/stimulus";
import { toggleSidePanel } from "../components/toggle_side_panel";
import { interpolate } from "../utils/string_utils";
import { postTurboRequest } from "../utils/http_utils";

export default class extends Controller {
  static targets = ["loaderTemplate", "content"];
  static values = { defaultOpenUrl: String };

  connect() {
    toggleSidePanel();

    if (this.defaultOpenUrlValue) {
      this.open(this.defaultOpenUrlValue);
    }

    document.addEventListener("sidePanel:open", this.onSidePanelOpen);

    document.addEventListener("sidePanel:close", this.onSidePanelClose);
  }

  disconnect() {
    document.removeEventListener("sidePanel:open", this.onSidePanelOpen);
    document.removeEventListener("sidePanel:close", this.onSidePanelClose);
  }

  onSidePanelOpen = (event) => {
    const { url, data = {} } = event.detail;
    this.open(url, data);
  };

  onSidePanelClose = () => {
    this.close();
  };

  collapse(event) {
    this.element.classList.add("reduced");
    event.stopImmediatePropagation(); // Prevents click event to be propagated to parent div, which would call the expand event below
  }

  expand() {
    this.element.classList.remove("reduced");
  }

  close() {
    this.element.classList.remove("show-side-panel", "reduced");
  }

  open(url, data = {}) {
    this.contentTarget.insertAdjacentHTML("afterbegin", interpolate(this.loaderTemplateTarget));
    this.element.classList.add("show-side-panel");

    postTurboRequest(url, data);
  }
}
